export default __webpack_public_path__ + "static/media/aliado-askha.0a326560.png";